import React, { useState } from "react";
import apiFetch from "../../utils/apiFetch";
import T4PreviewTopBar from "../../components/payroll/T4PreviewTopBar";

import { useT4SummaryPreview } from "./useT4SummaryPreview";
import { getToken } from "./helpers";
import Page1 from "./components/Page1";
import Page2 from "./components/Page2";

// T4PreviewTopBar is still untyped JS.
const TopBar = T4PreviewTopBar as any;

export default function T4Summary() {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState<number>(currentYear);

  const { data: sumData, isLoading: loading, error: queryError } =
    useT4SummaryPreview(year);

  const employer = sumData ? sumData.employer : null;
  const summary = sumData ? sumData.summary : null;
  const contact = sumData ? sumData.contact : null;
  const errMsg = queryError instanceof Error ? queryError.message : null;
  const error = errMsg ? "Could not load T4 Summary data: " + errMsg : "";

  const hasData = !loading && !error && employer && summary && contact;

  const handleDownload = async () => {
    const token = getToken();
    try {
      const res = await apiFetch(
        "/api/v1/payroll/taxes/t4-summary.pdf?year=" + year,
        { headers: { Authorization: "Bearer " + token } }
      );
      if (!res.ok) {
        alert("Could not generate PDF");
        return;
      }
      const blob = await res.blob();
      window.open(URL.createObjectURL(blob), "_blank");
    } catch (e) {
      alert(
        "Could not generate PDF: " +
          (e instanceof Error ? e.message : String(e))
      );
    }
  };

  return (
    <div
      style={{
        background: "#EDEFF2",
        fontFamily: "Arial, Helvetica, sans-serif",
        color: "#000",
        width: "100%",
        minHeight: "100vh",
      }}
    >
      <style>{`
        .t4-page { background:#fff; width:900px; max-width:100%; min-height:1160px; margin:24px auto; padding:26px 28px; box-shadow:0 1px 6px rgba(16,30,40,.16); font-size:10px; }
        @media print {
          @page { size: letter; margin: 0.35in; }

          html, body { background: #fff !important; margin: 0 !important; padding: 0 !important; }

          .t4-noprint { display: none !important; }

          body > div, body > div > div { background: #fff !important; }

          .t4-page {
            background: #fff !important;
            box-shadow: none !important;
            border: none !important;
            margin: 0 !important;
            padding: 0 !important;
            width: auto !important;
            max-width: 100% !important;
            min-height: 0 !important;
            height: auto !important;
            page-break-inside: avoid !important;
            page-break-after: always !important;
            break-after: page !important;
          }
          .t4-page:last-child {
            page-break-after: auto !important;
            break-after: auto !important;
          }

          .t4-cutline:after { display: none !important; }
        }
      `}</style>

      <TopBar
        title="T4 summary"
        subtitle={"2 pages · print or save as PDF · " + year}
        year={year}
        onYearChange={setYear}
        loading={loading}
        error={!!error}
        downloadDisabled={!hasData}
        onDownload={handleDownload}
      />

      {loading && (
        <div
          className="t4-page"
          style={{ textAlign: "center", padding: 60, fontSize: 14 }}
        >
          Loading T4 Summary data for {year}...
        </div>
      )}

      {error && !loading && (
        <div className="t4-page" style={{ padding: 40 }}>
          <div
            style={{
              background: "#FEF2F2",
              border: "1px solid #FCA5A5",
              borderRadius: 8,
              padding: "12px 16px",
              color: "#991B1B",
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            {error}
          </div>
        </div>
      )}

      {hasData && employer && summary && contact && (
        <>
          <Page1
            year={year}
            employer={employer}
            summary={summary}
            contact={contact}
          />
          <Page2 />
        </>
      )}
    </div>
  );
}